var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex block-message" }, [
    _c("div", { staticClass: "account__block_image" }, [
      _c("img", { attrs: { src: _vm.getAvatar, alt: "" } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c("div", { staticClass: "author-name" }, [
        _c("span", [_vm._v(_vm._s(_vm.author))]),
        _vm._v(" "),
        _c("span", { staticClass: "comment-created-at" }, [
          _vm._v(_vm._s(_vm.comment.created_at)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "comment-message" }, [
        _vm._v(_vm._s(_vm.comment.message)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }